import { Box, Text } from '@chakra-ui/react';
import { FaIcon } from '@acp/core-ui';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { format, parse } from 'date-fns';
import { useFormContext } from 'react-hook-form';
import { SubmitBookingFormSchemaValues } from './form-scheme';

const OasBookingTypeNames: { [key: string]: string } = {
    smoke: 'Smoke Alarms safety service',
    gas: 'Gas safety service',
    gas_further_works: 'Gas safety service',
    electrical: 'Electrical safety service',
    electrical_further_works: 'Electrical safety service',
    'electrical,smoke': 'Electrical and Smoke safety service',
    smoke_full_service: 'Smoke Alarms safety service',
    smoke_between_tenancy: 'Smoke Alarms safety service',
    smoke_further_works: 'Smoke Alarms safety service',
    smoke_upgrade_legislation_normal: 'Smoke Alarms safety service',
    smoke_upgrade_legislation_require_electrician: 'Smoke Alarms safety service',
};

export function ConfirmBookingCard() {
    const { getValues } = useFormContext<SubmitBookingFormSchemaValues>();

    const { startTime, endTime, date } = getValues('oasBooking.oasResult');
    const { bookingTypes } = getValues('oasBooking');

    const serviceName = bookingTypes !== undefined ? OasBookingTypeNames[bookingTypes.toString()] : 'Unknown service';
    const formattedTimeFrom = startTime !== undefined ? format(parse(startTime, 'HH:mm', new Date()), 'h:mm aaa') : '';
    const formattedTimeTo = endTime !== undefined ? format(parse(endTime, 'HH:mm', new Date()), 'h:mm aaa') : '';
    const formattedDate = date !== undefined ? format(parse(date, 'yyyy-MM-dd', new Date()), 'EEEE, do MMMM yyyy') : '';

    return (
        <Box mt={2} fontWeight="bold">
            <Text>
                <FaIcon icon={faClock} fontSize="md" mr={2} />
                {serviceName}
            </Text>
            <Text>
                {formattedDate}
            </Text>
            <Text>
                Between
                {' '}
                {formattedTimeFrom}
                {' - '}
                {formattedTimeTo}
            </Text>
        </Box>
    );
}
